import './AboutPage.css';

export default function AboutPage({ onClose }) {
  return (
    <div className="about-overlay" onClick={onClose}>
      <div className="about-modal" onClick={(e) => e.stopPropagation()}>
        <div className="about-header">
          <h2 className="about-title">About Us</h2>
          <button className="about-close" onClick={onClose}>×</button>
        </div>

        <div className="about-content">
          <div className="about-hero">
            <div className="about-logo">
              <span className="about-logo-icon">🔆</span>
              <span className="about-logo-text">Good<span>GPT</span></span>
            </div>
            <p className="about-tagline">The AI assistant that actually works for you.</p>
          </div>

          <div className="about-section">
            <h3>Our Mission</h3>
            <p>
              We're building AI tools that remember who you are — so you can spend less time
              managing information and more time doing meaningful work. GoodGPT combines persistent
              memory, intelligent research, email management, and career coaching in one place,
              personalised to you from day one.
            </p>
          </div>

          <div className="about-section">
            <h3>Company Details</h3>
            <div className="about-card">
              <div className="about-company-name">GOSHOPIN NOW (OPC) PRIVATE LIMITED</div>
              <div className="about-rows">
                <div className="about-row">
                  <span className="about-label">Location</span>
                  <span>Gurugram, Haryana, India</span>
                </div>
                <div className="about-row">
                  <span className="about-label">Incorporated</span>
                  <span>12 April 2024</span>
                </div>
                <div className="about-row">
                  <span className="about-label">CIN</span>
                  <span className="about-cin">U47912HR2024OPC120697</span>
                </div>
                <div className="about-row">
                  <span className="about-label">GSTIN</span>
                  <span className="about-cin">06AALCG1828J1ZG</span>
                </div>
                <div className="about-row">
                  <span className="about-label">Address</span>
                  <span>C-042, 4th Floor, Supermart, DLF Phase IV, Galleria DLF-IV, Gurgaon, Haryana, 122009, India</span>
                </div>
                <div className="about-row">
                  <span className="about-label">Contact</span>
                  <span><a href="mailto:info@goodgpt.site">info@goodgpt.site</a></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="about-footer">
          <button className="about-close-btn" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
